import { getEnv } from "../../lib/env";
import { useProductForm } from "../../contexts/ProductFormContext";

// Helper function to format euro values with 2 decimal places
export const formatEuro = (value: number) => `€ ${value.toFixed(2)}`;

// Helper function to format weights with 2 decimal places
export const formatWeight = (value: number) => `${value.toFixed(2)} kg`;

// Feature flag to control whether to use product form context
const ENABLE_PRODUCT_FORM =
  getEnv("VITE_ENABLE_PRODUCT_FORM", "false") === "true";

// Custom hook to safely handle conditional ProductForm usage
export const useSafeProductForm = () => {
  // Default values when provider is missing
  const defaultValues = { currentFormValues: null, isEditingProduct: false };

  // Always call the hook to satisfy React's rules
  try {
    // Try to use the form context, and if it fails, use default values
    return useProductForm();
  } catch (err) {
    // If feature flag is enabled, log the error
    if (ENABLE_PRODUCT_FORM) {
      console.error(
        "ProductFormProvider missing but feature flag is enabled:",
        err
      );
    }
    // Return default values
    return defaultValues;
  }
};

// Get status badge color based on request status
export const getStatusColor = (
  status: string
): "default" | "processing" | "success" | "error" | "warning" => {
  switch (status) {
    case "requested":
      return "processing";
    case "pending":
      return "warning";
    case "offer":
      return "warning";
    case "accepted":
      return "success";
    case "expired":
      return "default";
    default:
      return "default";
  }
};

// Get transport type color for tag
export const getTransportTypeColor = (transportTypeId: number | undefined) => {
  if (transportTypeId === 1) return "blue"; // Air
  if (transportTypeId === 2) return "orange"; // Sea
  return "default";
};
















